import axios from "axios";

const authAxios = axios.create({
	baseURL: "https://talkelectrical.com:5000/",
	headers: {
		"Content-type": "application/json"
	}
});
 
export default authAxios